import clsx from "clsx";
import { BadgeCheckIcon } from "lucide-react";

export const JobPipelineCandidateSheetVerificationBadge = ({
  className,
}: {
  className?: string;
}) => {
  return (
    <BadgeCheckIcon
      className={clsx("h-4 w-4 fill-primary-900 text-white", className)}
    />
  );
};
